var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38231 6.3138C7.92199 5.08217 9.87499 4.3457 12 4.3457C14.125 4.3457 16.078 5.08217 17.6177 6.3138L19.0711 4.86042L20.4853 6.27463L19.0319 7.72801C20.2635 9.26769 21 11.2207 21 13.3457C21 18.3163 16.9706 22.3457 12 22.3457C7.02944 22.3457 3 18.3163 3 13.3457C3 11.2207 3.73647 9.26769 4.9681 7.72801L3.51472 6.27463L4.92893 4.86042L6.38231 6.3138ZM12 20.3457C15.866 20.3457 19 17.2117 19 13.3457C19 9.47971 15.866 6.3457 12 6.3457C8.13401 6.3457 5 9.47971 5 13.3457C5 17.2117 8.13401 20.3457 12 20.3457ZM13 12.3457H16L11 18.8457V14.3457H8L13 7.8409V12.3457ZM8 1.3457H16V3.3457H8V1.3457Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.ad02a005477e2e0e0d283e939571d03b.svg";
export { ForwardRef as ReactComponent };